interface ViewsProps {
  children: React.ReactNode;
}

const Views = ({ children }: ViewsProps) => {
  return <>{children}</>;
};

export default Views;
